import { fetchAppConfigAPI } from '../../api/appConfig';
import { SET_APP_CONFIG, SET_APP_CONFIG_UI_FLAGS, SET_DOCUMENT_WIDTH, SET_WIDGET_LOCATION_URL } from '../types';
import ActionCableConnector from '../../helpers/actionCableConnector';
import { sendExceptionToSentry } from 'shared/helpers/sentry';

const state = {
  webChannelConfig: {
    enabledFeatures: [],
    widgetColor: '',
    outOfOfficeMessage: '',
  },
  authToken: '',
  contact: {
    pubsubToken: '',
  },
  globalConfig: {
    brandName: '',
    logoThumbnail: '',
    widgetBrandURL: '',
  },
  documentWidth: 0,
  widgetLocationUrl: '',
  uiFlags: {
    isFetching: false,
    isWidgetConfigured: false,
  },
};

const getters = {
  getWidgetColor: ($state) => $state.webChannelConfig.widgetColor,
  getOutOfOfficeMessage: ($state) => $state.webChannelConfig.outOfOfficeMessage,
  getWebChannelConfig: ($state) => $state.webChannelConfig,
  getWidgetConfigured: ($state) => $state.uiFlags.isWidgetConfigured,
  getGlobalConfig: ($state) => $state.globalConfig,
  getAuthToken: ($state) => $state.authToken,
  getContact: ($state) => $state.contact || {},
  getDocumentWidth: ($state) => $state.documentWidth,
  getWidgetLocationUrl: ($state) => $state.widgetLocationUrl,
};

const actions = {
  setAppConfig({ commit }, data) {
    commit(SET_APP_CONFIG, data);
  },
  setDocumentWidth({ commit }, docWidth) {
    commit(SET_DOCUMENT_WIDTH, docWidth);
  },
  setWidgetLocationUrl({ commit }, docWidth) {
    commit(SET_WIDGET_LOCATION_URL, docWidth);
  },
  async fetchAppConfig({ commit }, params) {
    commit(SET_APP_CONFIG_UI_FLAGS, { isFetching: true });
    try {
      const { data } = await fetchAppConfigAPI(params);
      window.HIVER_INBOX_ID = data?.chatwoot_website_channel?.working_hours[0]?.inbox_id;
      window.actionCable = new ActionCableConnector(
        window.WOOT_WIDGET,
        data.contact.pubsub_token
      );
      commit(SET_APP_CONFIG, data);
      commit(SET_APP_CONFIG_UI_FLAGS, { isWidgetConfigured: true });
    } catch (error) {
      sendExceptionToSentry(error);
    } finally {
      commit(SET_APP_CONFIG_UI_FLAGS, { isFetching: false });
    }
  },
};

const mutations = {
  [SET_DOCUMENT_WIDTH]($state, docWidth) {
    $state.documentWidth = docWidth;
   },
   [SET_WIDGET_LOCATION_URL]($state, url) {
    $state.widgetLocationUrl = url;
  },
  [SET_APP_CONFIG]($state, data) {
    const {
      website_channel_config: webChannelConfig,
      global_config: globalConfig,
    } = data;
    $state.webChannelConfig = {
      avatarUrl: webChannelConfig.avatar_url,
      csatSurveyEnabled: webChannelConfig.csat_survey_enabled,
      enabledFeatures: webChannelConfig.enabled_features,
      enabledLanguages: webChannelConfig.enabled_languages,
      hasAConnectedAgentBot: webChannelConfig.has_a_connected_agent_bot,
      locale: webChannelConfig.locale,
      outOfOfficeMessage: webChannelConfig.out_of_office_message,
      preChatFormEnabled: webChannelConfig.pre_chat_form_enabled,
      preChatFormOptions: webChannelConfig.pre_chat_form_options,
      replyTime: webChannelConfig.reply_time,
      useInboxAvatarForBot: webChannelConfig.use_inbox_avatar_for_bot,
      utcOffset: webChannelConfig.utc_off_set,
      websiteName: webChannelConfig.website_name,
      websiteToken: webChannelConfig.website_token,
      welcomeTagline: webChannelConfig.welcome_tagline,
      welcomeTitle: webChannelConfig.welcome_title,
      widgetColor: webChannelConfig.widget_color,
      workingHours: webChannelConfig.working_hours,
      workingHoursEnabled: webChannelConfig.working_hours_enabled,
    };
    $state.contact = {
      email: data.contact.email,
      id: data.contact.id,
      identifier: data.contact.identifier,
      name: data.contact.name,
      phone_number: data.contact.phone_number,
      pubsubToken: data.contact.pubsub_token,
    };
    $state.authToken = webChannelConfig.auth_token;
    $state.globalConfig = {
      brandName: globalConfig.BRAND_NAME,
      logoThumbnail: globalConfig.LOGO_THUMBNAIL,
      widgetBrandURL: globalConfig.WIDGET_BRAND_URL,
    };
  },
  [SET_APP_CONFIG_UI_FLAGS]($state, uiFlags) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...uiFlags,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
